import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=bfe966e4&scoped=true&"
import script from "./StatisticsChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsChart.vue?vue&type=style&index=0&id=bfe966e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe966e4",
  null
  
)

export default component.exports